"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ExpressViewState_1 = require("./ExpressViewState");
var styles = require("./ExpressView.scss");
var utils_1 = require("@idp/ui-components/utils");
var ReportingService_1 = require("../../../api/ReportingService");
var WirelessCart_1 = require("../../CartLob/WirelessCart/WirelessCart");
var ExpressCart_1 = require("../../CartLob/WirelessCart/ExpressCart");
var Utils = require("../../../utils/UtilityFunctions");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var components_1 = require("@idp/duc/components");
var ExpressView = /** @class */ (function (_super) {
    __extends(ExpressView, _super);
    function ExpressView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new ExpressViewState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.renderWireLessCart = _this.renderWireLessCart.bind(_this);
        _this.showHideLink = _this.showHideLink.bind(_this);
        _this.seeDetails = _this.seeDetails.bind(_this);
        return _this;
    }
    ExpressView.prototype.componentWillMount = function () {
        if (!this.props.data.isCollapsed) {
            this.setState({ isExpandView: true });
        }
    };
    ExpressView.prototype.render = function () {
        this.cmsContent = wlsUtils.getWlsCmsData();
        var isNewSAvingsAndPromo = this.props.data.savingsPromoComponentDisplay;
        return (React.createElement("div", null,
            this.renderWireLessCart(),
            !isNewSAvingsAndPromo && !Utils.unauthenticatedAccess() && this.showHideLink()));
    };
    ExpressView.prototype.seeDetails = function (showExpandView) {
        var linkText = this.state.isExpandView ? this.cmsContent.expupHideDetailsLabel :
            this.cmsContent.expupSeeDetailsLabel;
        this.reportingService.fireLinkClickWithOutPageLoad(linkText, CartUtilFunctions_1.getLinkClickBasekUrl());
        if (showExpandView) {
            this.setState({ isExpandView: true });
        }
        else {
            this.setState({ isExpandView: !this.state.isExpandView });
        }
    };
    ExpressView.prototype.renderWireLessCart = function () {
        var _a, _b;
        if (Utils.IsWirelessInCart()) {
            if (((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.isExpressUpgradeView) &&
                !((Utils.getCurrentFlowType() === Utils.LOBNames.LOB_PREPAID))) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(ExpressCart_1.default, { events: {
                            doLoading: this.props.events.doLoading, onDeviceChange: this.seeDetails,
                            onEdit: this.props.events.onEdit,
                        }, options: {
                            autoExpandPromoSection: this.props.data.autoExpandPromoSection,
                            isExpandView: this.state.isExpandView,
                            isExpressUpgradeView: this.props.data.isExpressUpgradeView,
                        }, promoPanelEvents: {
                            doLoading: this.props.promoPanelEvents && this.props.promoPanelEvents.doLoading,
                            priceBarUpdates: this.props.promoPanelEvents && this.props.promoPanelEvents
                                .priceBarUpdates,
                            showSaveCartModal: this.props.promoPanelEvents &&
                                this.props.promoPanelEvents.showSaveCartModal,
                        }, promoPanelOptions: {
                            autoExpandPromoSection: this.props.promoPanelOptions &&
                                this.props.promoPanelOptions.autoExpandPromoSection,
                            displayCloserCoupon: this.props.promoPanelOptions &&
                                this.props.promoPanelOptions.displayCloserCoupon,
                        }, crpEvents: {
                            crpStandaloneMessage: this.props.crpEvents && this.props.crpEvents.crpStandaloneMessage,
                        } })));
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(WirelessCart_1.default, { events: { doLoading: this.props.events.doLoading, onDeviceChange: this.seeDetails,
                        onEdit: this.props.events.onEdit }, options: { autoExpandPromoSection: this.props.data.autoExpandPromoSection,
                        isExpandView: this.state.isExpandView,
                        isExpressUpgradeView: this.props.data.isExpressUpgradeView }, promoPanelEvents: {
                        doLoading: this.props.promoPanelEvents && this.props.promoPanelEvents.doLoading,
                        priceBarUpdates: this.props.promoPanelEvents && this.props.promoPanelEvents.priceBarUpdates,
                        showSaveCartModal: this.props.promoPanelEvents &&
                            this.props.promoPanelEvents.showSaveCartModal
                    }, promoPanelOptions: {
                        autoExpandPromoSection: this.props.promoPanelOptions &&
                            this.props.promoPanelOptions.autoExpandPromoSection,
                        displayCloserCoupon: this.props.promoPanelOptions &&
                            this.props.promoPanelOptions.displayCloserCoupon,
                    } })));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    ExpressView.prototype.showHideLink = function () {
        var _this = this;
        var linkText = this.state.isExpandView ? this.cmsContent.expupHideDetailsLabel :
            this.cmsContent.expupSeeDetailsLabel;
        return (React.createElement("div", { className: styles.seedetailsLink },
            React.createElement(components_1.Link, { kind: "withAppendIcon", testId: utils_1.default('Cart', 'See', 'Details'), 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () { _this.seeDetails(); }, className: CartConfiguration_scss_1.commonLinkSmall, icon: this.state.isExpandView ?
                    React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.UP }) :
                    React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.DOWN }) }, linkText)));
    };
    return ExpressView;
}(React.Component));
exports.default = ExpressView;
//# sourceMappingURL=ExpressView.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/ExpressView/ExpressView.js
// module id = 2346
// module chunks = 8